import {  Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { VisitorManagementService } from '../visitor-management.service';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { ApiCallService } from 'src/app/service/api-call.service';
import { AppQrCodeService } from 'src/app/core/components/app-qr-code/app-qr-code.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { EcPoliciesService } from 'src/app/contractor/ec-policies';
import { FileDoc, FileUploadService } from 'src/app/core/components';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { BarcodeFormat } from '@zxing/library';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { LabourProfileImageComponent } from '../../labour/labours/create-sub-labour/labour-profile-image/labour-profile-image.component';
import { take, takeUntil } from 'rxjs/operators';
import { GLOBAL } from 'src/app/app.globals';

let fileToReturn: File;

@Component({
  selector: 'app-after-pre-request-visitor',
  templateUrl: './after-pre-request-visitor.component.html',
  styleUrls: ['./after-pre-request-visitor.component.css']
})
export class AfterPreRequestVisitorComponent implements OnInit {
  visitorId: string;
  visitorData: any = null;
  loading = true;
    public modalRef: any;
  date = (new Date()).toLocaleDateString('en-GB');
  hideUpdateiteams: boolean = true;
  editIndex: number = -1;
  iteamsViews: any[] = [];
  userId = localStorage.getItem('UserID') || '100';
  showPan: boolean;
  showPassport: boolean;
  otp: any;
    @ViewChild('uploadDocumentTemplateRef') public uploadDocumentTemplateRef: any;
    @ViewChild('registerface') public registerface: any;
    @ViewChild('video') videoElement: ElementRef;
    @ViewChild('signature') public signature: ElementRef<any>;
    @ViewChild('tempRef1') public tempRef1: any;
    @ViewChild('scanSerialTemplate') public scanSerialTemplate: any;
    @ViewChild('scanner') scanner: ZXingScannerComponent;
  allData: any;
   public visitorDocumentData: any[] = [];
  shortCodeWiseObjectMapping: any;
  docForm = new FormGroup({});
  uploadedFiles: FileDoc[] = [];
  files: any;
  photopath: any;
  croppedImage: any = '';
  savedCroppedImage: any = '';
  imageChangedEvent: any = '';
  photoname: any;
  showCropper = false;
  savedSignatueImage: any = '';
  signaturePadConfigration: any = {
    png: true,
    svg: true,
    jpg: true,
    undo: true
  };
  trainedData: any[] = [];
  label: string = '';
  system: string = '';
  scannerEnabled = false;
  scannerFormats: BarcodeFormat[] = [BarcodeFormat.QR_CODE];
  scannerMode: 'qr' | 'barcode' = 'qr';
  hasDevices: boolean | null = null;
  hasPermission: boolean | null = null;
  scannerError = '';
  availableDevices: MediaDeviceInfo[] = [];
  selectedDevice: MediaDeviceInfo | null = null;
  originalItems: any;

  createFormGroup(fields: string[], requiredFields: string[] = []): FormGroup {
    const group: any = {};
    fields.forEach(field => {
      group[field] = new FormControl(null, requiredFields.includes(field) ? Validators.required : null);
    });
    return new FormGroup(group);
  }

  visitorForm = this.createFormGroup([
    "Company_Code", "Plant_Code", "yourcompany", "name", "jobtitle",
    "mobileno", "emailid", "pgender","otp","passportNo","panNo",
    "emergencycontactname", "emergencycontactno","PCountry_Code",
    "address", "landmark", "zipcode", "PState_Code", "PDistrict_Code", "PCity_Code", 
    "PPostOffice_Code",
    "visitorcategoryasterList_Code", "TypeOfIdentityMasterItem_Code", 
    "addharNo", "drvingLicense", "electionCard",
    "Remark", "iteamtype", "iteamdescription", "serialno", "isreturnable",'CompanyName','EmployeePlant'
  ], [
    "yourcompany",
    "name",
    "jobtitle",
    "mobileno",
    "otp",
    "emergencycontactname",
    "emergencycontactno",
    "visitorcategoryasterList_Code",
    "TypeOfIdentityMasterItem_Code"
  ]);

  private readonly controlLabelMap: Record<string, string> = {
    yourcompany: 'Company name',
    name: 'Visitor name',
    jobtitle: 'Job title',
    mobileno: 'Mobile number',
    otp: 'OTP',
    emailid: 'Email address',
    emergencycontactname: 'Emergency contact name',
    emergencycontactno: 'Emergency contact number',
    visitorcategoryasterList_Code: 'Visitor category',
    TypeOfIdentityMasterItem_Code: 'Identity type',
    PCountry_Code: 'Country',
    PState_Code: 'State',
    PDistrict_Code: 'District',
    PCity_Code: 'City',
    PPostOffice_Code: 'Post office',
    address: 'Address',
    zipcode: 'Pin code'
  };

  public companyData: any[] = [];
  public plants: any[] = [];
  genderTypes: any;
  visitorcategory: any[] = [];
  identityTypes: any[] = [];
  show = false;
  showdrivinglicence = false;
  showelectioncard = false;
  iteamtypes: any;
  pStates: any[] = [];
  pCities: any[] = [];
  private onDestroy: Subject<any>;
  pPos: any[] = [];
  pcountries = [];
  visitorpurposetypeList: any;
  pDistricts = [];
  pVillages = [];
  lVillages = [];
    documentTypes = [];
    masterData = [];
      statusType: any;

  constructor(
    public sharedDataService: SharedDataService,
    private service: VisitorManagementService,
    private ecpolicyService: EcPoliciesService,
    private logHelperService: LogHelperService,
    private fileUploadService: FileUploadService,
    private route: ActivatedRoute,
        private modalService: NgbModal,
    public apiCall: ApiCallService,
    private qrCodeService: AppQrCodeService
  ) {
    this.onDestroy = new Subject();
  }

  ngOnInit() {
    this.visitorId = this.route.snapshot.paramMap.get('id');
    if (this.visitorId) {
      this.loadVisitorData();
      this.getShortCodeWiseMasterList();
    } else {
      this.logHelperService.logError({ message: 'Visitor ID not found' });
      this.loading = false;
    }
    this.initializeFormData();
    this.files = [];

    // Basic required field validation
    this.visitorForm.get('mobileno').setValidators([Validators.required, Validators.pattern(/^[0-9]{10}$/)]);
    this.visitorForm.get('otp').setValidators([Validators.required, Validators.pattern(/^[0-9]{6}$/)]);
    this.visitorForm.get('emergencycontactno').setValidators([Validators.required, Validators.pattern(/^[0-9]{10}$/)]);
  }
  private getShortCodeWiseMasterList() {
     this.statusType = [
        { Id: 1, Name: 'Approved' },
        { Id: 2, Name: 'Reject' },
      ];
    this.service.getMasterListData_V2("GM1080", null).subscribe(
      (res: any) => {
        const responseList = Array.isArray(res) ? res : [];
        const itemTypeGroup = responseList.find((x: any) => Number(x.Parent_Code) === 1079);
        const values = Array.isArray(itemTypeGroup.Values) ? itemTypeGroup.Values : [];

        this.iteamtypes = values.map((item: any) => ({
          MasterItem_Code: item.MasterItem_Code,
          Name: item.Name,
        }));
      },
      (error: any) => {
        this.iteamtypes = [];
      }
    );
  }
  
  initializeFormData() {
    // this.startCamera();
    const res = {
          "Page_Code": 424,
          "RequireType": 1,
          "ActionType": 0,
          "SelectedField": "Name,DocumentType_Code,page_code,IsMandatory,IsAuthorized,IsBeforeApproval,UpdatedBy_RoleCode",
          "Search": null,
          "UserId": this.userId
        }
        this.ecpolicyService.getDocumentTypesPageModuleWise(res).pipe(takeUntil(this.onDestroy)).subscribe((docTypes: any[]) => {
          this.documentTypes = docTypes.map((doc) => ({ ...doc }));
        });

    this.getVisitorCategory();
    this.identityProof();
  }

  loadVisitorData() {
    // Get visitor data by ID
    const reqObj = {
      Visitor_Code: this.visitorId,
      selectedField : null,
      Search :null,
      RequireType : 2,
      ActionType : 0,
      UserID : 0
    };

    this.apiCall.getAllVisitor(reqObj).subscribe((res: any) => {
      if (res && res.length > 0) {
        this.visitorData = res[0];
        if (this.visitorData.CarriedItems) {
  const items = typeof this.visitorData.CarriedItems === 'string'
    ? JSON.parse(this.visitorData.CarriedItems)
    : this.visitorData.CarriedItems;

  this.originalItems = JSON.parse(JSON.stringify(items)); // deep copy for comparison
  this.iteamsViews = items.map(item => ({
    ID: item.ID,
    Visitor_Code: item.Visitor_Code,
    ItemTypeMasterItem_Code: item.ItemTypeMIL_Code,
    ItemTypeMasterItem_Name: item.ItemName,
    ItemDescription: item.ItemDescription,
    SerialNo: item.SerialNo,
    isreturnable: item.IsReturnableIteam == 1
  }));
}
        this.populateForm();
        this.loading = false;
      } else {
        this.logHelperService.logError({ message: 'Visitor data not found' });
        this.loading = false;
      }
    }, (error) => {
      this.logHelperService.logError({ message: 'Error loading visitor data' });
      this.loading = false;
    });
  }

  populateForm() {
    if (this.visitorData) {
      this.visitorForm.patchValue({
        Company_Code: this.visitorData.Company_Code,
        Plant_Code: this.visitorData.Plant_Code,
        yourcompany: this.visitorData.VisitorCompany,
        name: this.visitorData.FullName,
        jobtitle: this.visitorData.JobTitle,
        mobileno: this.visitorData.MobileNo,
        emailid: this.visitorData.EmailID,
        pgender: this.visitorData.GenderMAsterItem_Code,
        emergencycontactname: this.visitorData.EmergancyContactName || '',
        emergencycontactno: this.visitorData.EmergancyContactNo || '',
        address: this.visitorData.Address1 || '',
        landmark: this.visitorData.Address2 || '',
        zipcode: this.visitorData.ZipCode || '',
        PState_Code: this.visitorData.State_Code,
        PDistrict_Code: this.visitorData.District_Code,
        PCity_Code: this.visitorData.City_Code,
        PPostOffice_Code: this.visitorData.PostOffice_Code,
        visitorcategoryasterList_Code: this.visitorData.VisitorCategoryMIL_Code,
        TypeOfIdentityMasterItem_Code: this.visitorData.IDProofTypeMIL_Code,
        addharNo: this.visitorData.AddharNo || '',
        drvingLicense: this.visitorData.DrivingLicenceNo || '',
        electionCard: this.visitorData.ElectionCardNo || '',
        Remark: this.visitorData.Remark || '',
        EmployeePlant : this.visitorData.EmployeePlant || '',
        CompanyName : this.visitorData.CompanyName || '',
      });
      this.changeIdentitytype();
      // Make email readonly and show verified
      this.visitorForm.get('emailid').disable();

      // Load address dropdowns if state/city codes exist
      if (this.visitorData.State_Code) {
        this.getStatesByCountryId();
      }
      if (this.visitorData.City_Code) {
        this.getCitiesByDistrict();
      }
      if (this.visitorData.PostOffice_Code) {
        this.getPostOfficeByCity();
      }
      if(this.visitorData.State_Code){
this.getDistrictsByStatePFromVal(this.visitorData.State_Code)
      }
      // Show appropriate ID proof field
      this.changeIdentitytype();
    }
  }
onChangeZipCode(zipcode) {
    if (zipcode.length === 6 && /^\d{6}$/.test(zipcode)) {
      this.getDetailsByZipCode(zipcode);
    } else {
      console.error('Invalid Zipcode:', zipcode);
    }
  }

  getDetailsByZipCode(zipCode: string) {
    const reqObj = {
      Filter: {
        ZipCode: zipCode,
        Search: null,
        RequiredFields: null,
        RequireType: 0,
        ActionType: 0,
        UserID: this.userId
      },
      Fields: [
        { keyName: 'Country_Code', DisplayName: 'Country' },
        { keyName: 'State_Code', DisplayName: 'State' },
        { keyName: 'District_Code', DisplayName: 'District' },
        { keyName: 'City_Code', DisplayName: 'City' },
        {
          keyName: 'PostOffice_Code',
          DisplayName: 'Village',
          ExtraFields: ['Pincode_Code', 'ZipCode']
        }
      ]
    };

    this.service.getZipCodesByData(reqObj).subscribe((response: any) => {
      if (response) {
        const country = response[0]
        const state = country.Values[0]
        const district = state.Values[0]
        const city = district.Values[0]
        const postOffice = city.Values[0]

        this.visitorForm.patchValue({
          PCountry_Code: country.Country_Code,
          PState_Code: state.State_Code,
          PDistrict_Code: district.District_Code,
          PCity_Code: city.City_Code,
          PPostOffice_Code: postOffice.PostOffice_Code,
        });

        this.pcountries = [{ Country_Code: country.Country_Code, Name: country.Country }];
        this.pStates = [{ State_Code: state.State_Code, StateName: state.State }];
        this.pDistricts = [{ District_Code: district.District_Code, DistrictName: district.District }];
        this.pCities = [{ City_Code: city.City_Code, Name: city.City }];
        this.pPos = [{ PostOffice_Code: postOffice.PostOffice_Code, PostOfficeName: postOffice.Village }];
      }
    });
  }

    getCountry() {
    return this.service.getCountry().subscribe((response: any) => {
      this.pcountries = response;
    });
  }

  getStatesByCountryIdP() {
    return this.service.getStatesByCountryId(this.visitorForm.controls['PCountry_Code'].value || 100)
      .subscribe((response: any) => {
        this.pStates = response;
      });
  }
  getDistrictsByStateP() {
    return this.service.getDistrictsByState(this.visitorForm.controls['PState_Code'].value || 100)
      .subscribe((response: any) => {
        this.pDistricts = response;
      });
  }
  getDistrictsByStatePFromVal(val) {
    return this.service.getDistrictsByState(val)
      .subscribe((response: any) => {
        this.pDistricts = response;
      });
  }
 getVillageP() {
    this.service.getVillageByPostOffice(this.visitorForm.controls['PPostOffice_Code'].value || 100).subscribe((response: any) => {
      this.lVillages = response.Data.Table;
    });
  }
 getPostOfficeByCityP() {
    this.service.getPOsByCity(this.visitorForm.controls['PCity_Code'].value || 100).subscribe((res: any) => {
      this.pPos = res;
    });
  }
  getVisitorCategory() {
    const reqObj: any = {
      ShortCode: null,
      Search: null,
      Parent_Code: 1065,
      Page_Code: 424,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    };
    this.service.visitorCategorys(reqObj).subscribe((response: any) => {
      this.visitorcategory = response;
    });
  }
   onChangeOTP(OTP) {
    if (OTP.length === 6 && /^\d{6}$/.test(OTP)) {
      this.OTPVerification(OTP);
    } else {
      console.error('Invalid OTP:', OTP);
    }
  }
  // tslint:disable-next-line: function-name
  UploadDoc(): void {

    this.modalRef = this.modalService.open(this.uploadDocumentTemplateRef,
      { size: 'lg', backdrop: 'static', keyboard: false, windowClass: 'modal-scrollbar-hide' });
  }

  TakePhoto(): void {

    this.modalRef = this.modalService.open(LabourProfileImageComponent, { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' });
    const modalRef = this.modalRef;
    modalRef.componentInstance.croppedImage.pipe(take(1)).subscribe((image: string) => {
      if (!image) {
        return;
      }
      this.croppedImage = image;
      this.savedCroppedImage = image;
      const fileName = `visitor-photo-${Date.now()}.png`;
      this.photopath = this.base64ToFile(image, fileName);
      this.photoname = fileName;
    });
  }
  RegisterFace(): void {
    this.modalRef = this.modalService.open(this.registerface, { windowClass: 'modal-scrollbar-hide' });
  }

  TakeSignature(): void {
    this.modalRef = this.modalService.open(this.signature, {
      backdrop: 'static',
      keyboard: false
    });
  }

  getItemTypeName(code: number): string {
  const found = this.iteamtypes ? this.iteamtypes.find(x => x.MasterItem_Code == code) : undefined;
  return found ? found.Name : 'N/A';
}
  saveSignature(dataURL: string) {
    this.savedSignatueImage = dataURL;
    this.modalRef.close();
  }
  Host() {
    console.log('form data open modal', this.visitorForm.getRawValue());
    const value = this.visitorForm.getRawValue();
    if (value.Company_Code != null && value.Plant_Code != null && value.yourcompany != null
      && value.name != null && value.jobtitle != null && value.emailid != null
      && value.otp != null && value.emergencycontactname != null && value.emergencycontactno != null && value.address != null
      && value.zipcode != null && value.PCountry_Code != null && value.PState_Code != null && value.PDistrict_Code != null
      && value.date != null && value.starttime != null && value.Enddate != null && value.endtime != null
      && value.temp != null) {
      this.modalRef = this.modalService.open(this.tempRef1,
        { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' });
      this.employeeDetail();
    } else {
      this.logHelperService.logError({
        message: 'Please Fill Mandotory Fields First'
      });
    }
  }
   employeeDetail() {

    return this.service.getEmployeeDetail().subscribe((res: any) => {
      this.allData = res;
    });
  }
  onChangeOtpIsValidate(Otp) {
    if (Otp.length === 6 && /^\d{6}$/.test(Otp)) {
      this.OTPVerification(Otp);
    } else {
      console.error('Invalid Otp:', Otp);
    }
  }
  generateOTP() {
    const reqObj: any = {
      MobileNo: this.visitorForm.controls['mobileno'].value,
      EmailID: null,
      Referance_Code: null,
      Page_Code: 424,
      ActionType: 0,
      RequirType: 0,
      UserId: this.userId
    }

    this.service.getOTP(reqObj).subscribe((response: any) => {
      this.visitorForm.patchValue({
        otp: response[0].OTP
      });
      this.otp = response[0].OTP;
      this.OTPVerification(response[0].OTP);
    });
  }
    OTPVerification(value: any) {
    const reqObj: any = {
      MobileNo: this.visitorForm.controls['mobileno'].value,
      EmailID: null,
      Page_Code: 424,
      OTP: value
    }

    this.service.getOTPVerification(reqObj).subscribe((response: any) => {
      if (response[0].Success == "Mobile Number Verified") {
        const otpControl = this.visitorForm.get('otp');
        otpControl.clearValidators();
        otpControl.updateValueAndValidity();
      }
    });
  }
  identityProof() {
    const reqObj: any = {
      ShortCode: null,
      Search: null,
      Parent_Code: 575,
      Page_Code: 424,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    };
    this.service.getIdentityProof(reqObj).subscribe((response: any) => {
      this.identityTypes = response;
    });
  }

  getStatesByCountryId() {
    // Assuming default country code 100 for India
    return this.service.getStatesByCountryId(100).subscribe((response: any) => {
      this.pStates = response;
    });
  }

  getCitiesByDistrict() {
    const districtControl = this.visitorForm.get('PDistrict_Code');
    const districtCode = districtControl ? districtControl.value : null;
    return this.service.getCitiesByDistrict(districtCode || 100).subscribe((response: any) => {
      this.pCities = response;
    });
  }

  getPostOfficeByCity() {
    const cityControl = this.visitorForm.get('PCity_Code');
    const cityCode = cityControl ? cityControl.value : null;
    return this.service.getPOsByCity(cityCode || 100).subscribe((res: any) => {
      this.pPos = res;
    });
  }

  changeIdentitytype() {
    const typeValue = this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].value;
    const addhar = this.visitorForm.get('addharNo');
    const pan = this.visitorForm.get('panNo');
    const passport = this.visitorForm.get('passportNo');
    const election = this.visitorForm.get('electionCard');
    const driving = this.visitorForm.get('drvingLicense');

    // reset flags
    this.show = false;
    this.showPan = false;
    this.showPassport = false;
    this.showelectioncard = false;

    // clear validators
    [addhar, pan, passport, election, driving].forEach(ctrl => {
      if (ctrl) {
        ctrl.clearValidators();
        ctrl.updateValueAndValidity();
      }
    });

    if (typeValue === 577) { // Aadhar Card
      this.show = true;
      addhar.setValidators([Validators.required]);
    } else if (typeValue === 576) { //Pan 
      this.showPan = true;
      pan.setValidators([Validators.required]);
    } else if (typeValue === 578) { // Election Card
      this.showelectioncard = true;
      election.setValidators([Validators.required]);
    } else if (typeValue === 580) {
      // Passport
      this.showPassport = true;
      passport.setValidators([Validators.required]);
    }

    // Update validity after setting validators
    [addhar, pan, passport, election, driving].forEach(ctrl => {
      if (ctrl) {
        ctrl.updateValueAndValidity();
      }
    });
  }

  generateQRCode(serialNo: string) {
    this.openSerialScanner('qr');
  }

  generateBarCode(serialNo: string) {
    this.openSerialScanner('barcode');
  }

  openSerialScanner(mode: 'qr' | 'barcode') {
    this.scannerMode = mode;
    this.scannerFormats = mode === 'qr'
      ? [BarcodeFormat.QR_CODE]
      : [
          BarcodeFormat.CODE_128,
          BarcodeFormat.CODE_39,
          BarcodeFormat.EAN_13,
          BarcodeFormat.EAN_8,
          BarcodeFormat.ITF,
          BarcodeFormat.CODABAR,
          BarcodeFormat.UPC_A,
          BarcodeFormat.UPC_E,
          BarcodeFormat.DATA_MATRIX,
          BarcodeFormat.PDF_417
        ];
    this.scannerEnabled = true;
    this.scannerError = '';
    this.hasDevices = null;
    this.hasPermission = null;
    this.availableDevices = [];
    this.selectedDevice = null;
    this.modalRef = this.modalService.open(this.scanSerialTemplate,
      { size: 'lg', backdrop: 'static', keyboard: true, windowClass: 'modal-scrollbar-hide' });
    this.modalRef.result.then(
      () => { this.scannerEnabled = false; },
      () => { this.scannerEnabled = false; }
    );
  }

  onSerialScan(resultString: string) {
    if (!resultString) return;
    this.visitorForm.patchValue({ serialno: resultString });
    this.scannerEnabled = false;
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  onCamerasFound(devices: MediaDeviceInfo[]) {
    this.availableDevices = devices || [];
    this.hasDevices = this.availableDevices.length > 0;
    if (this.availableDevices.length > 0) {
      this.selectedDevice = this.availableDevices[0];
    }
  }

  onCamerasNotFound() {
    this.hasDevices = false;
    this.scannerError = 'No camera devices found.';
  }

  onPermissionResponse(hasPermission: boolean) {
    this.hasPermission = hasPermission;
    if (!hasPermission) {
      this.scannerError = 'Camera permission denied. Please allow camera access.';
    }
  }

  onScanError(error: any) {
    this.scannerError = error ? String(error) : 'Scanner error';
    console.error('Scanner error:', error);
  }

  saveCroppedImage(type?: string): void {
    this.savedCroppedImage = this.croppedImage;
    if (type === 'uploadDoc') {
      if (!this.files || this.files.length === 0) {
        this.files = [];
        alert("Please upload document");
        return;
      }
    } else if (type === 'capturePhoto') {
      if (!this.imageChangedEvent) {
        return alert("Please upload image");
      }
    }
    this.modalRef.close();
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    if (this.imageChangedEvent && this.imageChangedEvent.target && this.imageChangedEvent.target.files && this.imageChangedEvent.target.files[0]) {
      fileToReturn = this.base64ToFile(
        event.base64,
        this.imageChangedEvent.target.files[0].name,
      );
      this.photopath = fileToReturn;
      this.photoname = this.imageChangedEvent.target.files[0].name;
    }
    return fileToReturn;
  }

  base64ToFile(data, filename) {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  imageLoaded() {
    this.showCropper = true;
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  rotateLeft(imageCropper: ImageCropperComponent) {
    imageCropper.rotateLeft();
  }

  rotateRight(imageCropper: ImageCropperComponent) {
    imageCropper.rotateRight();
  }

  cropperReady() {
    console.log('Cropper ready');
  }

  loadImageFailed() {
    console.log('Load failed');
  }
  isFileChanged: boolean = false
  onFilesChanged(newFiles: any) {
    this.files = newFiles;
    this.uploadedFiles = newFiles;
    this.isFileChanged = true;
  }

  getRecognizationPersonData(event: any): void {
    console.log('Recognized person data:', event);
  }

  getData(event: any): void {
    console.log('Face recognition training data:', event);
  }

  AddIteams() {
    let formData = this.visitorForm.value;
    if (!formData.iteamtype || !formData.iteamdescription || !formData.serialno) {
      this.logHelperService.logError({ message: 'Please Fill Item Type, Item Description, and Serial No' });
      return;
    }

    this.iteamtypes.forEach((result) => {
      if (result.MasterItem_Code == formData.iteamtype) {
        let reqObj = {
          ID: null,
          Visitor_Code: null,
          ItemTypeMasterItem_Code: formData.iteamtype,
          ItemTypeMasterItem_Name: result.Name,
          ItemDescription: formData.iteamdescription,
          SerialNo: formData.serialno,
          isreturnable: formData.isreturnable !== undefined ? formData.isreturnable : false
        };
        this.iteamsViews.push(reqObj);
        this.visitorForm.patchValue({
          iteamtype: null,
          iteamdescription: null,
          serialno: null,
          isreturnable: null,
        });
      }
    });
  }

  edititeams(index: number) {
    this.hideUpdateiteams = false;
    this.editIndex = index;
    let result = this.iteamsViews[index];
    this.visitorForm.patchValue({
      iteamtype: result.ItemTypeMasterItem_Code,
      iteamdescription: result.ItemDescription,
      serialno: result.SerialNo,
      isreturnable: Boolean(result.isreturnable)
    });
  }

  updateiteams() {
    if (this.editIndex < 0) return;
    const formData = this.visitorForm.value;
    if (!formData.iteamtype || !formData.iteamdescription || !formData.serialno) {
      this.logHelperService.logError({ message: 'Please Fill Item Type, Item Description, and Serial No' });
      return;
    }

    this.iteamtypes.forEach((result) => {
      if (result.MasterItem_Code == formData.iteamtype) {
        this.iteamsViews[this.editIndex] = {
          ID: this.iteamsViews[this.editIndex].ID || null,
          Visitor_Code: null,
          ItemTypeMasterItem_Code: formData.iteamtype,
          ItemTypeMasterItem_Name: result.Name,
          ItemDescription: formData.iteamdescription,
          SerialNo: formData.serialno,
          isreturnable: formData.isreturnable !== undefined ? formData.isreturnable : false
        };
        this.visitorForm.patchValue({
          iteamtype: null,
          iteamdescription: null,
          serialno: null,
          isreturnable: null,
        });
        this.editIndex = -1;
        this.hideUpdateiteams = true;
      }
    });
  }

  deleteiteams(index: number) {
    this.iteamsViews.splice(index, 1);
    this.hideUpdateiteams = true;
  }

  private formatDate(dateValue: any): string {
    if (!dateValue) return null;
    if (typeof dateValue === 'string') return dateValue;
    if (dateValue._isAMomentObject) {
      return dateValue.format('YYYY-MM-DD');
    }
    return new Date(dateValue).toISOString().split('T')[0];
  }

  public SubmitRequest(): void {
    Object.keys(this.visitorForm.controls).forEach(key => {
      this.visitorForm.get(key).markAsTouched();
    });
    if (this.visitorForm.invalid) {
      const invalidMessage = this.buildInvalidFieldMessage();
      if (invalidMessage) {
        this.logHelperService.logError({ message: invalidMessage });
      }
      return;
    }

    const value = this.visitorForm.getRawValue();
    const filteredArray = this.iteamsViews.map(({ isreturnable, ItemTypeMasterItem_Name, ...rest }) => rest);

    if (!this.visitorData) {
      this.logHelperService.logError({ message: 'Visitor metadata is missing. Please reload the page.' });
      return;
    }

    const visitorTableKey = 'FA3AE3BB-807F-4592-85E7-103F00D17853';
    const itemTableKey = '574CFB41-769F-4652-84D6-335AC9D25A8C';
    const requestTableKey = '0BF55340-7B38-4378-BC0D-73AD9CA06384';
    const requestApproverKey = '3D867CB0-029A-4EF8-A71B-0E58CF686196';

    const currentUserId = Number(this.userId) || 100;

    const payload: any = {
      [visitorTableKey]: {}
    };

    const addToPayloadIfChanged = (key: string, oldValue: any, newValue: any, force = false): void => {
      const hasOldValue = oldValue !== undefined && oldValue !== null;
      const hasNewValue = newValue !== undefined && newValue !== null;

      if (force || (oldValue != newValue)) {
        payload[visitorTableKey][key] = {
          OldValue: hasOldValue ? oldValue : null,
          NewValue: hasNewValue ? newValue : null
        };
      }
    };

    const normalizeNumberField = (updated: any, existing: any, fallback: number): number => {
      const baseValue = existing !== undefined && existing !== null ? existing : fallback;

      if (updated === null || updated === undefined || updated === '') {
        return baseValue;
      }
      const parsed = Number(updated);
      return Number.isNaN(parsed) ? baseValue : parsed;
    };

    const selectStringField = (updated: any, existing: any, fallback: any = null): any => {
      const baseValue = existing !== undefined && existing !== null ? existing : fallback;
      if (updated !== undefined && updated !== null && updated !== '') {
        return updated;
      }
      return baseValue;
    };

    const normalizedCompanyCode = normalizeNumberField(value.Company_Code, this.visitorData.Company_Code, 101);
    const normalizedPlantCode = normalizeNumberField(value.Plant_Code, this.visitorData.Plant_Code, 100);
    const normalizedCountryCode = normalizeNumberField(value.PCountry_Code, this.visitorData.Country_Code, 100);
    const normalizedStateCode = normalizeNumberField(value.PState_Code, this.visitorData.State_Code, 107);
    const normalizedDistrictCode = normalizeNumberField(value.PDistrict_Code, this.visitorData.District_Code, 0);
    const normalizedCityCode = normalizeNumberField(value.PCity_Code, this.visitorData.City_Code, 2827);
    const normalizedPostOfficeCode = normalizeNumberField(value.PPostOffice_Code, this.visitorData.PostOffice_Code, 19710);
    const normalizedVisitorCategory = normalizeNumberField(value.visitorcategoryasterList_Code, this.visitorData.VisitorCategoryMIL_Code, 1072);
    const normalizedIdentityType = normalizeNumberField(value.TypeOfIdentityMasterItem_Code, this.visitorData.IDProofTypeMIL_Code, 577);
    const normalizedGender = normalizeNumberField(value.pgender, this.visitorData.GenderMAsterItem_Code, 319);

    addToPayloadIfChanged('Visitor_Code', this.visitorData.Visitor_Code, this.visitorId, true);
    addToPayloadIfChanged('Company_Code', this.visitorData.Company_Code, normalizedCompanyCode);
    addToPayloadIfChanged('Plant_Code', this.visitorData.Plant_Code, normalizedPlantCode);
    addToPayloadIfChanged('VisitorCompany', this.visitorData.VisitorCompany, selectStringField(value.yourcompany, this.visitorData.VisitorCompany));
    addToPayloadIfChanged('FullName', this.visitorData.FullName, selectStringField(value.name, this.visitorData.FullName));
    addToPayloadIfChanged('GenderMAsterItem_Code', this.visitorData.GenderMAsterItem_Code, normalizedGender);
    addToPayloadIfChanged('JobTitle', this.visitorData.JobTitle, selectStringField(value.jobtitle, this.visitorData.JobTitle));
    addToPayloadIfChanged('MobileNo', this.visitorData.MobileNo, selectStringField(value.mobileno, this.visitorData.MobileNo));
    addToPayloadIfChanged('SmsOTP', this.visitorData.SmsOTP, selectStringField(value.otp ? String(value.otp) : value.otp, this.visitorData.SmsOTP));
    addToPayloadIfChanged('EmailID', this.visitorData.EmailID, selectStringField(value.emailid, this.visitorData.EmailID));
    addToPayloadIfChanged('EmergancyContactName', this.visitorData.EmergancyContactName, selectStringField(value.emergencycontactname, this.visitorData.EmergancyContactName));
    addToPayloadIfChanged('EmergancyContactNo', this.visitorData.EmergancyContactNo, selectStringField(value.emergencycontactno, this.visitorData.EmergancyContactNo));
    addToPayloadIfChanged('Address1', this.visitorData.Address1, selectStringField(value.address, this.visitorData.Address1));
    addToPayloadIfChanged('Address2', this.visitorData.Address2, selectStringField(value.landmark, this.visitorData.Address2));
    addToPayloadIfChanged('ZipCode', this.visitorData.ZipCode, selectStringField(value.zipcode, this.visitorData.ZipCode));
    addToPayloadIfChanged('Country_Code', this.visitorData.Country_Code, normalizedCountryCode);
    addToPayloadIfChanged('State_Code', this.visitorData.State_Code, normalizedStateCode);
    addToPayloadIfChanged('District_Code', this.visitorData.District_Code, normalizedDistrictCode);
    addToPayloadIfChanged('City_Code', this.visitorData.City_Code, normalizedCityCode);
    addToPayloadIfChanged('PostOffice_Code', this.visitorData.PostOffice_Code, normalizedPostOfficeCode);
    addToPayloadIfChanged('VisitorCategoryMIL_Code', this.visitorData.VisitorCategoryMIL_Code, normalizedVisitorCategory);
    addToPayloadIfChanged('IDProofTypeMIL_Code', this.visitorData.IDProofTypeMIL_Code, normalizedIdentityType);
    addToPayloadIfChanged('AddharNo', this.visitorData.AddharNo, selectStringField(value.addharNo, this.visitorData.AddharNo));
    addToPayloadIfChanged('PassportNo', this.visitorData.PassportNo, selectStringField(value.passportNo, this.visitorData.PassportNo));
    addToPayloadIfChanged('PanNo', this.visitorData.PanNo, selectStringField(value.panNo, this.visitorData.PanNo));
    addToPayloadIfChanged('ElectionCardNo', this.visitorData.ElectionCardNo, selectStringField(value.electionCard, this.visitorData.ElectionCardNo));
    addToPayloadIfChanged('DrivingLicenceNo', this.visitorData.DrivingLicenceNo, selectStringField(value.drvingLicense, this.visitorData.DrivingLicenceNo));
    addToPayloadIfChanged('Remark', this.visitorData.Remark, selectStringField(value.Remark, this.visitorData.Remark));
    addToPayloadIfChanged('EmployeePlant', this.visitorData.EmployeePlant, selectStringField(value.EmployeePlant, this.visitorData.EmployeePlant));
    addToPayloadIfChanged('CompanyName', this.visitorData.CompanyName, selectStringField(value.CompanyName, this.visitorData.CompanyName));
    addToPayloadIfChanged('CreatedBy', this.visitorData.CreatedBy !== undefined && this.visitorData.CreatedBy !== null ? this.visitorData.CreatedBy : currentUserId, currentUserId, true);
    addToPayloadIfChanged('ModifiedBy', this.visitorData.ModifiedBy !== undefined && this.visitorData.ModifiedBy !== null ? this.visitorData.ModifiedBy : currentUserId, currentUserId, true);

 const payloadItems = [];
const currentItems = this.iteamsViews || [];
const originalItems = this.originalItems || [];

// 🔹 1. Handle New & Updated
currentItems.forEach(item => {

  const existing = originalItems.find(o => o.ID === item.ID);

  // 🟢 NEW ITEM
  if (!item.ID) {
    payloadItems.push({
      ID: null,
      Visitor_Code: this.visitorData.Visitor_Code,
      ItemTypeMIL_Code: item.ItemTypeMasterItem_Code,
      ItemDescription: item.ItemDescription,
      SerialNo: item.SerialNo,
      IsReturnableIteam: item.isreturnable ? 1 : 0,
      IsDelete: 0,
      CreatedBy: currentUserId,
      ModifiedBy: currentUserId
    });
  }

  // 🟡 UPDATED ITEM
  else if (existing) {

    const itemPayload: any = {
      ID: {
          OldValue: existing.ID ? existing.ID : null,
          NewValue: item.ID ? item.ID : null
        }, // ✅ PRIMARY KEY DIRECT
        Visitor_Code: {
          OldValue: existing.Visitor_Code ? existing.Visitor_Code : null,
          NewValue: this.visitorData.Visitor_Code ? this.visitorData.Visitor_Code : null
        }, 
    };

    const addIfChanged = (key: string, oldVal: any, newVal: any) => {
      if (oldVal != newVal) {
        itemPayload[key] = {
          OldValue: oldVal ? oldVal : null,
          NewValue: newVal ? newVal : null
        };
      }
    };

    addIfChanged(
      'ItemTypeMIL_Code',
      existing.ItemTypeMasterItem_Code,
      item.ItemTypeMasterItem_Code
    );

    addIfChanged(
      'ItemDescription',
      existing.ItemDescription,
      item.ItemDescription
    );

    addIfChanged(
      'SerialNo',
      existing.SerialNo,
      item.SerialNo
    );

    addIfChanged(
      'IsReturnableIteam',
      existing.IsReturnableIteam,
      item.isreturnable ? 1 : 0
    );

    // Only push if something changed
    if (Object.keys(itemPayload).length > 2) {
      payloadItems.push(itemPayload);
    }
  }
});

originalItems.forEach(original => {
  const stillExists = currentItems.find(c => c.ID === original.ID);
  if (!stillExists) {
    payloadItems.push({
      ID: {
        OldValue: original.ID ? original.ID : null,
        NewValue: original.ID ? original.ID : null,
      },
      Visitor_Code: {
          OldValue: original.Visitor_Code ? original.Visitor_Code : null,
          NewValue: original.Visitor_Code ? original.Visitor_Code : null,
        }, 
      IsDelete: {
        OldValue: 0,
        NewValue: 1
      },
    });
  }
});
if (payloadItems.length) {
  payload[itemTableKey] = payloadItems;
}
 if (this.isFileChanged) {
        let unmatchedIDs = [];
        this.visitorDocumentData.forEach(item1 => {
          let matchFound = false;
          let matchInArray1 = this.uploadedFiles.find(item2 => item2.ID === item1.ID);

          if (matchInArray1) {
            unmatchedIDs.push({
              ...matchInArray1,
              ID: item1.ID,
            });
            matchFound = true;
            const indexToRemove = unmatchedIDs.findIndex(item => item.ID === item1.ID);
            if (indexToRemove !== -1) {
              unmatchedIDs.splice(indexToRemove, 1);
            }
          }
          if (!matchFound) {
            unmatchedIDs.push({ ID: { oldValue: item1.ID, newValue: item1.ID }, isdelete: { OldValue: 0, NewValue: 1 } });
          }
        })
      }
   if(this.photopath){
    let cleanBase64 = this.croppedImage;

  if (cleanBase64 && cleanBase64.includes('base64,')) {
    cleanBase64 = cleanBase64.split('base64,')[1];
  }

        payload["4E3A518F-CAF3-4938-A2B0-7C9D2660F85A"] = [
                   {
                    "ID": null, // Auto Set
                    "Referance_Code": this.visitorData.Visitor_Code, // Auto Set
                    "RefTypeMasterList_Code": "1007", // Static Value
                    "DocumentTypeMasterList_Code": "175",
                    "ParentRootFolder": "Documents\\LicenseDocument\\", // Static value
                    "UploadFileName": this.photopath.name,
                    "Size": this.photopath.size ? (this.photopath.size / 1024).toFixed(2) + ' KB' : null,
                    "Page_Code": 192, // Static Value // License Master
                    "CreateBy":   this.userId ? this.userId : null,
                    "ModifiedBy": this.userId ? this.userId : null,
                    "Document": cleanBase64 // Base64 string
                  }]
      }

    this.service.updateVisitor(payload).subscribe(
      (response: any) => {
        this.logHelperService.logSuccess({ message: 'Visitor details updated successfully' });
        const uploadParams = {
        Visitor_Code: this.visitorId
      };
       
        // Generate and auto-download QR code with payload for prefill
        const qrData = JSON.stringify({
          type: 'visitor_pre_request',
          version: 1,
          data: {
            visitorCode: this.visitorId,
            Company_Code: value.Company_Code,
            Plant_Code: value.Plant_Code,
            VisitorCompany: value.yourcompany,
            FullName: value.name,
            JobTitle: value.jobtitle,
            MobileNo: value.mobileno,
            EmailID: value.emailid,
            GenderMAsterItem_Code: value.pgender,
            EmergancyContactName: value.emergencycontactname,
            EmergancyContactNo: value.emergencycontactno,
            Address1: value.address,
            Address2: value.landmark,
            ZipCode: value.zipcode,
            State_Code: value.PState_Code,
            City_Code: value.PCity_Code,
            PostOffice_Code: value.PPostOffice_Code,
            VisitorCategoryMIL_Code: value.visitorcategoryasterList_Code,
            IDProofTypeMIL_Code: value.TypeOfIdentityMasterItem_Code,
            AddharNo: value.addharNo || null,
            PassportNo: value.passportNo || null,
            PanNo: value.panNo || null,
            ElectionCardNo: value.electionCard || null,
            DrivingLicenceNo: value.drvingLicense || null,
            Remark: value.Remark || '',
            Items: this.iteamsViews || []
          }
        });
        
        this.qrCodeService.generateQRCode(qrData, 320, true);
      },
      (error) => {
        this.logHelperService.logError({
          message: 'Error updating visitor: ' + (error.error && error.error.Message ? error.error.Message : 'Unknown error')
        });
      }
    );
  }

  private buildInvalidFieldMessage(): string | null {
    const invalidKeys = Object.keys(this.visitorForm.controls).filter(key => this.visitorForm.controls[key].invalid);
    if (!invalidKeys.length) {
      return null;
    }
    const labels = Array.from(new Set(invalidKeys.map(key => this.getFriendlyLabel(key))));
    if (!labels.length) {
      return null;
    }
    const visibleLabels = labels.slice(0, 4);
    const suffix = labels.length > visibleLabels.length ? ', ...' : '';
    return `Please correct the following fields: ${visibleLabels.join(', ')}${suffix}.`;
  }

  private getFriendlyLabel(key: string): string {
    if (this.controlLabelMap[key]) {
      return this.controlLabelMap[key];
    }
    const cleanedKey = key
      .replace(/_/g, ' ')
      .replace(/Code$/i, '')
      .replace(/MasterItem/gi, '')
      .replace(/MIL/gi, '')
      .trim();
    if (cleanedKey) {
      return cleanedKey.charAt(0).toUpperCase() + cleanedKey.slice(1);
    }
    return key;
  }
}

